module.exports = __webpack_public_path__ + "img/页面图片修改2-6.c1c6ceaa.png";